import * as React from "react";
import { useState } from 'react';
import { TileLayout } from "@progress/kendo-react-layout";
import AssetAllocation from "./assetAllocation-chart";
import PortfolioReviewGrid from "./portfolioReview-grid";
import AssetPerformance from "./assetPerf-chart";
import family from './data/familyData.json';
import assetDetails from './data/assetAllocationData.json';


const Portfolio = () => {
 
  const [assetAllocationSelectedButton, setassetAllocationButton] = useState('Asset Class');
  const [assetPerfSelectedButton, setAssetPerfButton] = useState(3);
  const [portfolioReviewSelectedButton, setportfolioReviewButton] = useState(0);

   const assetAllocationButtonClick = (event) => {
    setassetAllocationButton(event.target.value);
  };
  const assetPerfButtonClick = (index) => {
    setAssetPerfButton(index);
  };
  const portfolioReviewGridButtonClick = (index) => {
    setportfolioReviewButton(index);
  };

const assetAllocationbuttonNames = [
  { value: 'Asset Class', label: 'Asset Class' },
  { value: '2', label: '2' },
  { value: '3', label: '3' }   
];
const assetPerfButtonNames = ['MTD', 'QTD', 'YTD', '1Y', '3Y', '5Y'];
const portfolioReviewGridButtonNames = ['Quarterly', 'Monthly'];

const assetPerfButtons = assetPerfButtonNames.map((name, index) => (
  <button key={index} className={`non-gappable-button ${assetPerfSelectedButton === index ? 'selected-non-gappable-button' : ''}`}  onClick={() => assetPerfButtonClick(index)} > {name} </button>
));
const portfolioReviewGridButtons = portfolioReviewGridButtonNames.map((name, index) => (
  <button key={index} className={`non-gappable-button ${portfolioReviewSelectedButton === index ? 'selected-non-gappable-button' : ''}`}  onClick={() => portfolioReviewGridButtonClick(index)} > {name} </button>
));

  const [data, setData] = React.useState([{
    col: 1,
    colSpan: 2,
    rowSpan: 2
  },
  {
    col: 1,
    colSpan: 4,
    rowSpan: 4
  },
  {
    col: 3,
    colSpan: 2,
    rowSpan: 2
  },
]);
  const tiles = [
    {
      header: <div className="header-container"><b>Asset Allocation </b> 
      <select className="dropdownOptions" options={assetAllocationbuttonNames} defaultValue={assetAllocationSelectedButton} onChange={assetAllocationButtonClick}>
                {assetAllocationbuttonNames.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
      </select>
      </div>,
      body: <AssetAllocation assetDetails={assetDetails} />
    },
  {
    header: <div className="header-container"><b> Detailed Portfolio Review </b><div className="button-container">{portfolioReviewGridButtons}</div></div>,
    body: <PortfolioReviewGrid data={family} />
  },

  {
    header: <div className="header-container" ><b> Asset by Performance </b><div className="button-container">{assetPerfButtons}</div></div>,
    body: <div>
          <AssetPerformance assetDetails={assetDetails} />
        </div>
  },
  ];

  const handleReposition = e => {
    setData(e.value);
  };


  return( <>

      <div id="content" className="dashboard p-3 home">
         <div className="row m-0"> 
        </div>
        <div className="row mt-3">

          <div id="content" className="dashboard">
            <TileLayout columns={4} rowHeight={255} positions={data} gap={{
              rows: 10,
              columns: 10
            }} items={tiles} onReposition={handleReposition} />
          </div>
        </div>
     </div>   
  </>
  )
};
export default Portfolio;